export interface AuthUser {
  id: string;
  email: string;
  display_name: string | null;
  tier: "trial" | "creator" | "vibecoder" | "expired" | "past_due";
  trial_ends_at: string | null;
  google_linked: boolean;
  discord_linked: boolean;
  default_model: string | null;
  default_thinking: boolean;
}

// Tool parts from cloudflare ai-chat use `type: "tool-${toolName}"` format,
// built by the message-builder's applyChunkToParts(). The SDK's UIMessagePart
// union doesn't cover this shape.
export interface ToolUIPart {
  type: string; // "tool-mind_recall", "tool-mind_store", etc.
  toolCallId: string;
  toolName: string;
  state: "input-streaming" | "input-available" | "output-available" | "output-error" | "approval-requested" | "output-denied";
  input?: unknown;
  output?: unknown;
  errorText?: string;
  textOffset?: number;
}

export function isToolPart(part: { type: string }): part is ToolUIPart {
  return part.type.startsWith("tool-") && "toolCallId" in part;
}
